import mainCaller from './mainCaller';

// 지점 공용 즐겨찾기 — targetType 만 바꾸면 어떤 목록에서도 같은 API 를 쓴다.
export const FAVORITE_TARGET = {
  TICKET: 'TICKET',
  PASS: 'PASS',
  TRIAL: 'TRIAL',
  // 판매등록 모달 전용 집합 — 회원권 관리 목록의 즐겨찾기와 별개
  SALE_TICKET: 'SALE_TICKET',
  SALE_PASS: 'SALE_PASS',
  SALE_TRIAL: 'SALE_TRIAL',
};

// 멱등 set. favorite=true 등록, false 해제. 응답 { favorite }
export async function setFavorite(token, { branchId, targetType, targetId, favorite }) {
  return await mainCaller('admin/api/v1/favorites', 'PUT', { branchId, targetType, targetId, favorite }, {
    Authorization: `Bearer ${token}`,
  });
}

// 단건 조회(상세 화면 별표용). 응답 { favorite }
export async function getFavorite(token, { branchId, targetType, targetId }) {
  return await mainCaller(
    `admin/api/v1/favorites?branchId=${branchId}&targetType=${targetType}&targetId=${targetId}`,
    'GET',
    null,
    { Authorization: `Bearer ${token}` },
  );
}
